angular.module('app').directive('reportTable', function() {
    return {
        'restrict': 'A',
        'templateUrl': 'report-table.html',
        'scope': {
            'data': '=reportTable'
        }
    };
});
